import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { ICap } from "cap/model"
import { IFormConfigurationCaps } from "form/model"
import React from "react"
import { CampaignSummaryColumn } from "./CampaignSummaryColumn"
import { CampaignSummaryItem } from "./CampaignSummaryItem"

interface CampaignCapsSummaryProps {
  caps: IFormConfigurationCaps
  contentWidth: number
}

export const CampaignCapsSummary = React.memo(({ caps, contentWidth }: CampaignCapsSummaryProps) => {
  if (caps.month === null && caps.week === null && caps.day === null && caps.hour === null && caps.minute === null) {
    return (
      <Typography id="summary-caps-empty" color="textSecondary" fontSize=".85rem" sx={{ ml: "1rem" }}>
        {translate("cap.label.empty")}
      </Typography>
    )
  }
  return (
    <CampaignSummaryColumn contentWidth={contentWidth} twoColumns>
      {(["month", "week", "day", "hour", "minute"] as Array<keyof IFormConfigurationCaps>).map(
        (cap, index) =>
          caps[cap] !== null && (
            <CampaignSummaryItem
              id={`summary-caps-${index}`}
              title={translate(`cap.label.${cap}`)}
              value={(caps[cap] as ICap).frequency}
            />
          )
      )}
    </CampaignSummaryColumn>
  )
})
